import React from "react";
import { ModalProps, Modal } from "semantic-ui-react";
import { IPerson } from "../../models/IPerson";
import PersonForm from "./PersonForm";
import { useCreatePerson } from "../../data/persons/useCreatePerson";
import { useTexts } from "@common/hooks/useTexts";
import { IPersonFormData } from "../../models/IPerson";

interface AddPersonModalProps extends ModalProps {
    onSuccess: (person: IPerson) => void;
    onCancel: () => void;
    requiredCerts?: Array<string>;
    inputForCertStartDate?: boolean;
};

const AddPersonModal: React.FC<AddPersonModalProps> = ({
    onSuccess,
    onCancel,
    requiredCerts,
    inputForCertStartDate,
    ...modalProps
}) => {

    const texts = useTexts((t) => ({
        addCompany: t("Lisää henkilö"),
    }));

    const { create, creating } = useCreatePerson();

    const _onSubmit = async (values: IPersonFormData) => {
        const result = await create(values);
        if (result.isSuccess) {
            onSuccess(result.value);
        };
    };


    return (
        <Modal className="AddPersonModal" {...modalProps} onClose={onCancel}>
            <Modal.Content>
                <h3> {texts.addCompany} </h3>
                <PersonForm
                    onSubmit={_onSubmit}
                    onCancel={onCancel}
                    loading={creating}
                    requiredCerts={requiredCerts}
                    inputForCertStartDate={inputForCertStartDate}
                />
            </Modal.Content>
        </Modal>
    );
};


export default AddPersonModal;
